
import React, { useRef, useEffect } from "react";
import { useEvangelismAssistant } from "./EvangelismAssistantProvider";
import { ScrollArea } from "@/components/ui/scroll-area";

type MessageListProps = {
  isLoading: boolean;
};

const MessageList: React.FC<MessageListProps> = ({ isLoading }) => {
  const { messages } = useEvangelismAssistant();
  const messageEndRef = useRef<HTMLDivElement>(null);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [messages]);

  return (
    <ScrollArea className="h-[450px] pr-4">
      <div className="space-y-4 pb-2">
        {messages.map((msg) => (
          <div 
            key={msg.id} 
            className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
          >
            <div 
              className={`max-w-[80%] rounded-lg p-3 ${
                msg.sender === 'user' 
                  ? 'bg-heaven-gold/10 text-heaven-dark-gold text-xs sm:text-sm' 
                  : 'bg-gray-100 text-gray-800 text-xs sm:text-sm'
              }`}
            >
              {msg.text}
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="flex justify-start">
            <div className="max-w-[80%] rounded-lg p-3 bg-gray-100">
              <div className="flex space-x-2">
                <div className="w-2 h-2 rounded-full bg-gray-300 animate-bounce"></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                <div className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: '0.4s' }}></div>
              </div>
            </div>
          </div>
        )}
        <div ref={messageEndRef} />
      </div>
    </ScrollArea>
  );
};

export default MessageList;
